import * as React from "react";
import {cx} from "emotion";

import "./mailing-image.scss";

import {cs}    from "@Common/react/chain-services";
import {keyed} from "@Common/react/keyed";

import {InlineZoomPreviewImg} from "./inline-zoom-preview-img";

export const MailingImage = ({className=undefined, representativeImage=undefined, loading=false}) => cs(
    () => (
        <div className={cx("mailing-image-25z", className)}>

            {loading ? (
                <div {...{
                    className: "loading",
                    "xd-qa-type": "image",
                    "xd-qa-name": "Mailing Image Loading",
                }}>
                    {Corners({})}
                    <i className="fa fa-spinner fa-pulse"/>
                </div>
            ) : !representativeImage ? (
                <div {...{
                    className: "no-mailing-image",

                    "xd-qa-type": "image",
                    "xd-qa-name": "No Mailing Image",
                }}>
                    {Corners({})}
                    <div className="message">
                        A black and white image of your mailing piece goes here
                    </div>
                </div>
            ) : (
                <div {...{
                    className: "mailing-image",

                    "xd-qa-type": "image",
                    "xd-qa-name": "Mailing Image Preview",
                }}>
                    {representativeImage && InlineZoomPreviewImg({
                        className: "img",
                        src: representativeImage,
                    })}
                </div>
            )}
        </div>
    ),
);

const Corners = ({}) => [
        "top left",
        "top right",
        "bottom right",
        "bottom left",
    ]
        .map((cln) => cs(
            keyed(cln),
            () => (
                <div className={cx("corner", cln)}/>
            )
        ))
;
